module.exports = __webpack_public_path__ + "img/clbaogao.28b73509.png";